import React from "react";

export default function TecnicasIncrementoSensorial() {
  return (
    <div className="p-4 max-w-xl mx-auto flex flex-col gap-4">
      {/* Encabezado */}
      <div className="flex items-center justify-center">
        <h4 className="font-bold text-center">Técnicas de incremento sensorial</h4>
      </div>

      {/* Introducción */}
      <div className="text-justify">
        <p className="mb-2">
          Estas técnicas alertan al SNC antes de deglutir (aumentan la conciencia sensorial).
        </p>

        <p className="mb-2">
          Indicadas en pacientes con apraxia deglutoria, déficits sensitivos o retraso del disparo deglutorio.
        </p>

        <ul className="list-disc pl-6 space-y-1">
          <li>Estimulación mecánica de la lengua: presionar dorso lengua con cuchara al introducir alimento.</li>
          <li>Estimulación mecánica de musculatura buccinadora.</li>
          <li>Estimulación mecánica pilares faríngeos con frío.</li>
          <li>Estimulación térmica y cambios de sabores: ácidos, fríos.</li>
          <li>Estimulación olfativa y visual.</li>
          <li>Autoalimentación: permite que el mecanismo de la deglución sea más automático.</li>
          <li>Masticación: proporciona sensación oral adicional necesaria para desencadenar reflejo.</li>
        </ul>
      </div>
    </div>
  );
}